import { Input, Badge, Typography, Row, Col, Space, Grid } from 'antd'
import { BellFilled } from '@ant-design/icons'

import UserSetting from 'components/UserSetting'

import Styled from './styled'
const { useBreakpoint } = Grid

export default function Page ({
  children,
  title,
  searchPlaceholder,
  showSearch = true,
  onSearch = () => null,
  onBlur,
}) {
  const screens = useBreakpoint()
  const user = JSON.parse(localStorage.getItem('user'))
  return (
    <Styled className='page-component'>
      {/* <Space direction='vertical' size='large' style={{ width: '100%' }}> */}
      <div className='page-header' style={{ paddingBottom: 8 }}>
        <Row
          justify='space-between'
          style={{
            position: 'fixed',
            zIndex: 3,
            backgroundColor: '#f2f3f7',
            width: '100%',
            paddingTop: '2vh',
          }}
        >
          <Col xs={24}>
            <Space size='large' style={{ width: '100%' }}>
              <Row gutter={[15, 5]}>
                <Col>
                  <Typography.Title style={{ fontSize: screens?.lg ? 38 : 32 }}>
                    {title}
                  </Typography.Title>
                </Col>
              </Row>
            </Space>
          </Col>
        </Row>
        <Row
          justify='space-between'
          style={{
            paddingTop: '2vh',
          }}
        >
          <Col xs={12}>
            <Space size='large' style={{ width: '100%' }}>
              <Row gutter={[15, 5]}>
                <Col>
                  <Typography.Title style={{ color: '#f2f3f7' }}>{title}</Typography.Title>
                </Col>
                <Col
                  sm={24}
                  lg={10}
                  className='search-block'
                  style={{ zIndex: screens?.lg ? 4 : 2 }}
                >
                  {showSearch && (
                    <Input.Search
                      size='large'
                      placeholder={searchPlaceholder}
                      onSearch={onSearch}
                      style={{ width: '280px', zIndex: 7 }}
                    />
                  )}
                </Col>
              </Row>
              {/* <div className='title-block'>
              </div> */}
            </Space>
          </Col>
          {/* {console.log('screens', screens)} */}
          <Col style={{ zIndex: screens?.xs ? 1 : 4 }}>
            <div className='account-block'>
              <div className='icon-block'>
                <Badge dot offset={[-6, 6]}>
                  <BellFilled />
                </Badge>
              </div>
              <div className='name-block'>
                <div className='name'>
                  <Typography.Text strong>{user.employee.employee_name_th}</Typography.Text>
                </div>
                <div className='role'>
                  <Typography.Text type='secondary'>
                    Role: {user.profile.role.role_name}
                  </Typography.Text>
                </div>
                <div className='profile'>
                  <Typography.Text type='secondary'>
                    Profile: {user.profile.profile_name}
                  </Typography.Text>
                </div>
              </div>
              <div className='avatar-block'>
                <UserSetting />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <div className='page-content'>{children}</div>
      {/* </Space> */}
    </Styled>
  )
}
